var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import DateTimePicker from "react-datetime-picker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/pro-solid-svg-icons";
import { parseRelativeDate } from "@/components/forms/components/utils";
import moment from "moment";
import Input from "@mui/joy/Input";
import { useAppSelector } from "@/hooks/store";
import { getCurrentUserDateFormat } from "@/store/utils/selectors/userSelector";
/**
 * Format de date par défaut
 */
export var defaultDateFormat = "DD/MM/YYYY";
/** <b>Composant d'affichage en mode édition d'un champ de type Date</b>*/
export default function DateFieldEdit(_a) {
    var record = _a.record, fieldName = _a.fieldName, onUpdate = _a.onUpdate, _b = _a.format, format = _b === void 0 ? defaultDateFormat : _b, fieldMetadata = _a.fieldMetadata, isMassUpdate = _a.isMassUpdate, isOnStudio = _a.isOnStudio, isReport = _a.isReport;
    /*
    const { data: queryResult } = useGetCurrentUserQuery(null);
    const user_preferences = queryResult?.data?.preferences?.date;
    const dateFormat = user_preferences?.date_format;
    */
    var dateFormat = useAppSelector(getCurrentUserDateFormat);
    var formatDate = useMemo(function () { return (dateFormat ? dateFormat : format); }, [format, dateFormat]);
    /**
     * Valuer par défaut du champ
     */
    var defaultValue = useMemo(function () {
        var r = record || {};
        return isReport
            ? record.value
            : fieldName && r[fieldName]
                ? new Date(r[fieldName])
                : (fieldMetadata.display_default &&
                    new Date(parseRelativeDate(fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.display_default))) ||
                    new Date();
    }, [record, fieldName]);
    /**
     * Valeur à afficher sur le champ
     */
    var _c = useState(), value = _c[0], setValue = _c[1];
    useEffect(function () {
        setValue(isReport ? moment(record.value).toDate() : defaultValue);
    }, [defaultValue]);
    var newFormatString = useMemo(function () {
        return formatDate
            .replace("m", "MM")
            .replace("Y", "yyyy")
            .replace("d", "D")
            .replace("H", "HH")
            .replace("i", "mm");
    }, [formatDate]);
    /**
     * Gestion de la mise à jour du champ
     * Envoyer la mise à jour au parent
     */
    var onDateUpdate = useCallback(function (dateTime) {
        var _a, _b;
        if (!onUpdate) {
            return;
        }
        if (!dateTime || isNaN(dateTime.getTime())) {
            onUpdate((_a = {},
                _a[fieldName] = new Date(),
                _a));
            return;
        }
        var date = moment(dateTime);
        var formattedDate = date.format(newFormatString);
        onUpdate((_b = {},
            _b[fieldName] = formattedDate,
            _b));
    }, [fieldName, onUpdate, newFormatString]);
    return (_jsx("div", __assign({ className: "" }, { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsx(DateTimePicker, { className: "ml-1 !border-[var(--colors-input-border)] !border rounded-md !bg-[var(--colors-input-bg)] !text-[var(--colors-input-text)] ", onChange: onDateUpdate, 
            //value={value}
            value: value, format: newFormatString.replaceAll("D", "dd"), calendarIcon: _jsx(FontAwesomeIcon, { icon: faCalendarDays }) })) }), fieldName));
}
